<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        @openEditFormDialog="openEditFormDialog"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="800px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :prjCategoryCode="editFormDialogOptions.code"
        :createDataVisible="editFormDialogOptions.createDataVisible"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l("INDEX.btn_cancel") || 取消
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l("INDEX.btn_save") || 保存 }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
};

export default {
  name: "projectManagement-category",
  components: {
    PageHeader: () => import("./components/header/index"),
    PageMain: () => import("./components/main"),
    EditForm: () => import('./components/main/components/detail')
  },
  data() {
    return {
      table: [],
      page: {...initPage},
      loading: false,
      editFormDialogOptions: {
        visible: false,
        code: "",
      },
    };
  },
  methods: {
    reset() {
      this.page = {
        ...initPage
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .prjCategoryListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.main.fromLoad('add')
    },
    openEditFormDialog({ type, code = "" }) {
      const types = {
        edit: this.$l('INDEX.btn_tips_edit')||"编辑项目类别信息",
        add: this.$l('INDEX.product_dialog_btn_add')||"增加项目类别信息",
        detail: this.$l('INDEX.btn_tips_view')||"项目类别详情",
      };

      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === "detail",
        createDataVisible: type != 'add',
      };
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false;
    },
  },
};
</script>
